import styled from 'styled-components';
import { color, space, font, query } from '@design/templateFns';

export const NullMessageContainer = styled.div`
  max-width: 550px;
  padding-right: ${space('xl')};
  padding-left: ${space('xl')};
  margin-left: auto;
  margin-right: auto;
  text-align: center;
`;

export const NullContainer = styled.div`
  margin: ${space('x12')} 0;
`;

export const SVGContainer = styled.div`
  margin-bottom: ${space('x7')};

  @media screen and (${query.below('tablet')}) {
    svg {
      width: 110px;
    }
  }
`;

export const Headline = styled.h3`
  ${font('headline-xxs')};
  padding-bottom: ${space('xl')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('headline-xs')};
    padding-bottom: ${space('lg')};
  }
`;

export const Description = styled.p`
  ${font('body-sm-light')};
  color: ${color('gray5')};
  padding-bottom: ${space('x7')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md-light')};
    padding-bottom: ${space('x8')};
  }
`;

export const ButtonContainer = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${space('xl')};

  @media screen and (${query.below('tablet')}) {
    display: block;

    a {
      margin-bottom: ${space('xl')};
    }
  }
`;

export const IllustrationWrapper = styled.div`
  max-width: 548px;
  margin-top: ${space('x7')};
  margin-left: auto;
  margin-right: auto;

  svg {
    width: 100%;
    height: auto;
  }
`;
